import React from "react";
import { Col, Row, Form } from "react-bootstrap";
import Dropdown from "react-dropdown";
import deleteIconImg from "./../../assets/img/delete.png";
import { Image } from "react-bootstrap-v5";
import {
  CreateNewSavedFilter,
  GetAllSavedFilters,
  GetOneSavedFilterByHash,
  DeleteOneSavedFilter,
} from "../../Utils/saved_filters.util";

class SavedSearchFiltersComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSaveFilterAddForm: false,
      savedFilterList: [],
      savedNameOfFilter: "",
      responseSavedFilter: "",
      savedFilterDropdownOptions: [],
      selectedFilter: null
    };

    this.onSaveFilter = this.onSaveFilter.bind(this);
    this.deleteSavedFilter = this.deleteSavedFilter.bind(this);
    this.getAllSaveFiltersList = this.getAllSaveFiltersList.bind(this);
    this.onChangeSavedFilter = this.onChangeSavedFilter.bind(this);
  }

  // Call auto on page load
  componentDidMount() {
    this.getAllSaveFiltersList();
  }

  /**
   * Get All Filters
   */
  getAllSaveFiltersList = () => {
    // Load into the dropdown of Saved Filters
    GetAllSavedFilters().then((response) => {
      if (response.statusCode == 200 && response.result) {
        this.setState({
          savedFilterDropdownOptions: response.result.map((filter) => {
            return {
              value: filter.filterHash,
              label: filter.filterName,
            };
          }),
          showSaveFilterAddForm: false,
        });
      }
    });
  };

  /**
   * Save filter stuff
   */
  onSaveFilter = () => {
    if (this.state.savedNameOfFilter.trim()) {
      /** Filter to save in DB */
    
      const zipStateCityCounty = {
        zipCode: this.props.filterState.searchZipCode,
        state: this.props.filterState.stateShort,
      };

      if (this.props.filterState.city) {
        zipStateCityCounty.city = this.props.filterState.city;
      } else if (this.props.filterState.county) {
        zipStateCityCounty.counties = this.props.filterState.counties;
      }

      if (this.props.filterState.street) {
        zipStateCityCounty.street = this.props.filterState.street;
      }

      const propertyCharacteristics = {
        classification: this.props.filterState.classification,
        propertyTypes: this.props.filterState.propertyType,
        bedroomMin: this.props.filterState.bedroomMin,
        bedroomMax: this.props.filterState.bedroomMax,
        bathroomMin: this.props.filterState.bathroomMin,
        bathroomMax: this.props.filterState.bathroomMax,
        buildingAreaMin: this.props.filterState.buildingAreaMin,
        buildingAreaMax: this.props.filterState.buildingAreaMax,
        yearBuildMin: this.props.filterState.yearBuildMin,
        yearBuildMax: this.props.filterState.yearBuildMax,
        effectiveYearBuiltMin: this.props.filterState.effectiveYearBuiltMin,
        effectiveYearBuiltMax: this.props.filterState.effectiveYearBuiltMax,
        residentialUnitsMin: this.props.filterState.residentialUnitsMin,
        residentialUnitsMax: this.props.filterState.residentialUnitsMax,
        commercialUnitsMin: this.props.filterState.commercialUnitsMin,
        commercialUnitsMax: this.props.filterState.commercialUnitsMax,
        lotSizeMin: this.props.filterState.lotSizeMin,
        lotSizeMax: this.props.filterState.lotSizeMax,
        lotSizeAcresMin: this.props.filterState.lotSizeAcresMin,
        lotSizeAcresMax: this.props.filterState.lotSizeAcresMax,
        vacantFlag: this.props.filterState.vacantFlag,
        siteInfluence: this.props.filterState.siteInfluence,
      };

      const mls = {
        listingDateMin: this.props.filterState.listingDateMin,
        listingDateMax: this.props.filterState.listingDateMax,
        listingStatus: this.props.filterState.listingStatus,
        daysOnMarketMin: this.props.filterState.daysOnMarketMin,
        daysOnMarketMax: this.props.filterState.daysOnMarketMax,
      };

      const preforeclosure = {
        preforeclosureStatus: this.props.filterState.preforeclosureStatus,
        preforeclosureRecordingDateMin:
          this.props.filterState.preforeclosureRecordingDateMin,
        preforeclosureRecordingDateMax:
          this.props.filterState.preforeclosureRecordingDateMax,
        preforeclosureAuctionDateMin:
          this.props.filterState.preforeclosureAuctionDateMin,
        preforeclosureAuctionDateMax:
          this.props.filterState.preforeclosureAuctionDateMax,
        preforeclosureVeryLikeylyToDefault:
          this.props.filterState.preforeclosureVeryLikeylyToDefault,
        preforeclosureLikeylyToDefault:
          this.props.filterState.preforeclosureLikeylyToDefault,
        preforeclosureUnLikeylyToDefault:
          this.props.filterState.preforeclosureUnLikeylyToDefault,
        preforeclosureExclude: this.props.filterState.preforeclosureExclude,
        preforeclosureActiveAuction:
          this.props.filterState.preforeclosureActiveAuction,
      };

      const owner = {
        ownerType: this.props.filterState.ownerType,
        yearsOfOwnershipMin: this.props.filterState.yearsOfOwnershipMin,
        yearsOfOwnershipMax: this.props.filterState.yearsOfOwnershipMax,
        lastSaleDateMin: this.props.filterState.lastSaleDateMin,
        lastSaleDateMax: this.props.filterState.lastSaleDateMax,
        lastSalePriceMin: this.props.filterState.lastSalePriceMin,
        lastSalePriceMax: this.props.filterState.lastSalePriceMax,
        ownerOccupied: this.props.filterState.ownerOccupied,
        // coorporateOwned: this.state.coorporateOwned,
        isTaxDelinquent: this.props.filterState.isTaxDelinquent,
        taxDelinquentYearMin: this.props.filterState.taxDelinquentYearMin,
        taxDelinquentYearMax: this.props.filterState.taxDelinquentYearMax,
        mailingState: this.props.filterState.mailingState,
      };

      const valuation = {
        estimatedValueMin: this.props.filterState.estimatedValueMin,
        estimatedValueMax: this.props.filterState.estimatedValueMax,
        equityPercentageMin: this.props.filterState.equityPercentageMin,
        equityPercentageMax: this.props.filterState.equityPercentageMax,
        assessedLandValueMin: this.props.filterState.assessedLandValueMin,
        assessedLandValueMax: this.props.filterState.assessedLandValueMax,
        assessedTotalValueMin: this.props.filterState.assessedTotalValueMin,
        assessedTotalValueMax: this.props.filterState.assessedTotalValueMax,
        marketLandValueMin: this.props.filterState.marketLandValueMin,
        marketLandValueMax: this.props.filterState.marketLandValueMax,
        marketTotalValueMin: this.props.filterState.marketTotalValueMin,
        marketTotalValueMax: this.props.filterState.marketTotalValueMax,
      };

      const mortgage = {
        mortgageInterestRateMin: this.props.filterState.mortgageInterestRateMin,
        mortgageInterestRateMax: this.props.filterState.mortgageInterestRateMax,
        mortgageAmountMin: this.props.filterState.mortgageAmountMin,
        mortgageAmountMax: this.props.filterState.mortgageAmountMax,
        mortgageRecordingDateMin:
          this.props.filterState.mortgageRecordingDateMin,
        mortgageRecordingDateMax:
          this.props.filterState.mortgageRecordingDateMax,
      };

      const weather = {
        weatherEventType: this.props.filterState.weatherEventType,
        weatherEventTypeDataMin: this.props.filterState.weatherEventTypeDataMin,
        weatherEventTypeDataMax: this.props.filterState.weatherEventTypeDataMax,
        weatherEventLastDays: this.props.filterState.weatherEventLastDays,
      };

      const filter = {
        ...zipStateCityCounty,
        ...propertyCharacteristics,
        ...mls,
        ...preforeclosure,
        ...owner,
        ...valuation,
        ...mortgage,
        ...weather,
      };

      CreateNewSavedFilter(this.state.savedNameOfFilter, filter).then(
        (response) => {
          if (response.status == "OK") {
            this.getAllSaveFiltersList();
            this.setState({
              responseSavedFilter: "Filter saved successfully.",
            });
            setTimeout(() => this.setState({ responseSavedFilter: "" }), 2000);
          }
        }
      );
    }
    this.setState({ savedNameOfFilter: "" });
    this.setState({ selectedFilter: null});
  };

  /**
   * On change load the values
   * @param {*} opt
   */
  onChangeSavedFilter = (opt) => {
    if (!opt.value) return;
    GetOneSavedFilterByHash(opt.value).then((response) => {
      if (response.statusCode == 200 && response.result?.searchCriteria) {
         this.props.handleSavedFilterSelectedValues(response.result.searchCriteria)
      }
    });
    this.setState({selectedFilter: opt})
  };

  /**
   * delete by hash
   * @param {*} opt 
   * @returns 
   */
  deleteSavedFilter = () => {
    if (!this.state.selectedFilter.value) return;

    DeleteOneSavedFilter(this.state.selectedFilter.value).then((response) => {
      if (response.statusCode == 200) {
        this.getAllSaveFiltersList();
        this.props.handleClearAllFilter(1);
        this.setState({
          selectedFilter: null,
          responseSavedFilter: "Filter deleted successfully.",
        });
        setTimeout(() => this.setState({ responseSavedFilter: "" }), 2000);
      }
    });
  };

  render() {
    return (
      <>
        <div className="filter-saved mt-2">
          <div>
            <label>
              Save custom filters to quickly reuse and streamline your searches.
            </label>
            <button
              onClick={() => this.setState({ showSaveFilterAddForm: true })}
            >
              Save this selection
            </button>
          </div>
        </div>

        {this.state.showSaveFilterAddForm ? (
          <>
            <div className="filter-saved">
              <div>
                <Row>
                  <Col md={12}>
                    <label className="mb-0 mb-2">Name of Filter</label>
                  </Col>
                  <Col lg={12} sm={6}>
                    <input
                      type="text"
                      value={this.state.savedNameOfFilter}
                      onChange={(e) =>
                        this.setState({ savedNameOfFilter: e.target.value })
                      }
                      className="px-2"
                      placeholder="Enter a Name"
                      maxLength={80}
                    ></input>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <button
                      className="dark"
                      onClick={(e) => {
                        this.onSaveFilter();
                      }}
                    >
                      Save
                    </button>
                  </Col>
                  <Col lg={4}>
                    <button
                      onClick={(e) => {
                        this.setState({ showSaveFilterAddForm: false });
                      }}
                    >
                      Cancel
                    </button>
                  </Col>
                </Row>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        {!this.state.showSaveFilterAddForm &&
        this.state.savedFilterDropdownOptions?.length ? (
          <div className="filter-saved mb-4">
            <Row>
              {this.state.responseSavedFilter != "" ? (
                <>
                  <Col lg={12}>
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                    >
                      {this.state.responseSavedFilter}
                    </div>
                  </Col>
                </>
              ) : (
                <></>
              )}
              <Col md={12}>
                <label className="mb-0 mb-2">Saved Filters</label>
              </Col>
              <Col lg={10}>
                <Dropdown
                  options={this.state.savedFilterDropdownOptions}
                  placeholder={"Select Saved Filter"}
                  className="select-saved-filter"
                  onChange={this.onChangeSavedFilter}
                  value={this.state.selectedFilter}
                />
              </Col>
              <Col lg={2}>
                <Image
                  className="deleteIconImg"
                  title="Delete Filter"
                  disabled={this.state.showDeleteIcon == true ? false : true}
                  src={deleteIconImg}
                  onClick={this.deleteSavedFilter}
                ></Image>
              </Col>
            </Row>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default SavedSearchFiltersComponent;
